<script>
import UsersApi from "@/services/users-api";
import simplebar from "simplebar-vue";

export default {
    components: {
        simplebar
    },
    mounted(){
        this.getUsers()

    },
    data(){
        return{
            pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
            usersFilter:null,
            isUsersTableBusy:false,
            usersListFields: 
                [
                    { key:"name", label: "Nom",   sortable: false, tdClass:"font-weight-bold  ",},
                    { key:"jobTitle", label: "Fonction",thClass:"",tdClass:"" },
                    { key:"userName", label: "Login",thClass:"",tdClass:"" },
                    { key:"password", label: "Mot de passe",thClass:"",tdClass:"" },
                   // { key:"isAdmin", label: "Admin",   thClass:"text-center", tdClass:"text-center"},
                    { key:"status", label: "Statut",   thClass:"text-center", tdClass:"text-center"},
                    { key:"actions", label:""}
                ],
            selectedUser:{id:'',name:'',userName:'',password:'',supplierId:null,status:1,},
            brandsList:[],
            showPasswordModal:false,
            passwordHidden:true,
            newPassword:null,
            showClientsModal:false,
            clientsList:[],
            pagemodelCustomersList: {currentPage : 1, perPage :10, totalRows: 0},
            customersListFields: 
                [   
                    { key:"selection",label:"",thClass:"text-center align-middle", tdClass:"text-left align-middle"},
                    { key:"companyName", label: "",   sortable: false, thClass:"text-center align-middle", tdClass:"font-weight-bold align-middle ",},
                    { key:"extId", label: "",   sortable: false, thClass:"text-center align-middle", tdClass:" align-middle ",},
                    { key:"country.name", label: "",   sortable: false,thClass:"text-center align-middle", tdClass:"align-middle",},
                    { key:"city.name", label: "",   sortable: false ,thClass:"text-center align-middle", tdClass:" align-middle",},
                ],
            customersListFieldsForAdmin: 
                [
                    { key:"companyName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"country.name", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"city.name", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                ],
            customerTableBusy:false,
            selectedCustomer:new Set(),
            editUsersModal:false,
            isNew:false,

            selectedPriviliges:[],
            
            selectedUserPriviligesList:[],
            selectedUserPriviligesListFields: 
                [
                    { key:"fullName", label: "",   sortable: false, tdClass:"font-weight-bold ",},
                    { key:"actions", label:"",thClass:"text-right", tdClass:"text-right"}
                ],
            allCustomersAreSelected:0,
            editSelectionStaring:false,
            customersFilter:null,

            usersList: [],
            
        }
    },
    methods:{

        getUsers(){
            this.isUsersTableBusy = true;
            UsersApi.getUsers(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.usersFilter).then(
                  response => {    
                    this.usersList= response.list
                    this.pagemodelMain.totalRows = response.total;
                    this.pagemodelMain.currentPage = response.page;
                    this.pagemodelMain.perPage = response.pageSize;
                    this.pagemodelMain.pageSize = response.pageSize;
                  }
              ).finally(() => {
             this.isUsersTableBusy = false;
                });
        },
        showHidePassword(){
            this.passwordHidden=!this.passwordHidden
        },
        changePassword(user){
            this.selectedUser=user
            this.passwordHidden=true
            this.newPassword=null
            this.showPasswordModal=true
        },
        updatePassword(){
            UsersApi.updatePassword(this.selectedUser.id,this.newPassword).then(
                (result)=>{
                    if(result){
                        this.showPasswordModal=false
                        this.selectedUser={}
                    }
                }
            )
        },

        getUsersClients(){
            this.customerTableBusy=true
            UsersApi.getUsersClients(this.pagemodelCustomersList.currentPage,this.pagemodelCustomersList.perPage,this.selectedUser==null ? null : this.selectedUser.id,this.customersFilter).then(
                (result)=>{
                    if(result){
                        this.clientsList=result.list
                        this.pagemodelCustomersList.totalRows = result.total;
                        this.pagemodelCustomersList.currentPage = result.page;
                        this.pagemodelCustomersList.perPage = result.pageSize;
                        this.pagemodelCustomersList.pageSize = result.pageSize;
                        var addedToTraderCount=0;
                        for(const i in this.clientsList){
                            if(this.clientsList[i].isAddedToTrader==1){
                                addedToTraderCount++;
                            }  
                        }
                        if(addedToTraderCount == this.pagemodelCustomersList.pageSize ){
                            this.allCustomersAreSelected = 1
                        }else{
                            this.allCustomersAreSelected = 0
                        }
                    }
                }
            ).finally(()=>{
                this.showClientsModal=true
                this.customerTableBusy=false
            })
        },

       

        addNewUser(){
            this.selectedUser={id:'',name:'',userName:'',password:'',supplierId:null,status:1},
            this.cancelUserEdit()
            this.isNew=true
            this.passwordHidden=true
            this.editUsersModal=true
        },

        cancelUserEdit(){
            this.selectedUser.status=1;
            this.selectedUser.isAdmin = false
            this.selectedUser.id=null
            this.selectedUser.name=''
            this.selectedUser.userName=''
            this.selectedUser.password=''
        },

        saveUser(){

            

            this.selectedUser.supplierId= this.selected ? this.selected.id : null
            this.selectedUser.customerId= null
            UsersApi.saveUser(this.selectedUser).then(
                (result)=> {
                    if(result){
                        this.getUsers()          
                        this.cancelUserEdit()
                        this.editUsersModal=false
                    }

                }
            )
        },

        editUser(user){
            this.selectedUser.id=user.id
            this.selectedUser.status=user.status
            this.selectedUser.isAdmin=user.isAdmin
            this.selectedUser.name=user.name
            this.selectedUser.userName=user.userName
            this.selectedUser.phone=user.phone
            this.selectedUser.jobTitle=user.jobTitle
            this.isNew=false
            this.editUsersModal=true
        },



        editSelection(item){
            
            if(this.selectedUser.hasAdminPrivilege){
                return;
            }

            if(item == null){
                return;
            }
            
            this.editSelectionStaring=true

            let array = [];
            array.push(item.id)
            UsersApi.editSelection(array ,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getUsersClients(this.selectedUser)
                    }
                }
            ).then(
                ()=>{
                    this.editSelectionStaring=false
                }
            )
        },

        selectAllCustomers(){
            if(this.selectedUser.hasAdminPrivilege){
                return;
            }

            let array = [];

            for(const i in this.clientsList){
                array.push(this.clientsList[i].id)
            }

            UsersApi.editSelection(array ,this.selectedUser==null ? null : this.selectedUser.id).then(
                (result)=>{
                    if(result){
                        this.getUsersClients(this.selectedUser)
                    }
                }
            )

        },

        openClientsModal(user){
            this.selectedCustomer= new Set()
            this.pagemodelCustomersList= {currentPage : 1, perPage :10, totalRows: 0}
            this.selectedUser=user
            this.getUsersClients(user);

        },

        onClientsModalClose() {
            this.getUsers();
        }
        
        },


}
</script>

<template>
    <div>
        <div class="row mt-4 pt-4 pb-4">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <b-form-group :label="$t('users.placeholder')">
                    <b-input-group  >
                        <b-form-input :placeholder="$t('users.nameFilter')"   v-model="usersFilter"   @keyup.native.enter="getUsers() "
                            ></b-form-input>                              
                        <template v-slot:append>
                            <b-button variant="primary" @click="getUsers()" >
                            <i class="bx bx-search-alt font-weight-bold font-size-16 text-white align-middle"></i>
                            </b-button>
                        </template>
                    </b-input-group>
                </b-form-group>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">


                <b-button variant="outline-primary" @click="addNewUser()" class="mb-4 float-right">
                    <i class="  fas fa-plus-square font-size-16 font-weight-bold align-middle mr-2 "></i> 
                    <span class="  font-weight-bold">
                       {{$t('users.addNew')}}  
                    </span>
                </b-button>
            </div>
        </div>
        <div class="table-responsive"> 
            <b-table 
            :busy="isUsersTableBusy"
            :striped="true"
            :small="false"
            :hover="true"
            :items="usersList"
            :fields="usersListFields"
            :perPage="pagemodelMain.perPage"
            class="table  "
            >
            <template v-slot:table-busy>
                <div class="text-center my-2">
                    <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                </div>
            </template>
            <template v-slot:head(name)>
                {{ $t("users.table.name") }} 
            </template>
            <template v-slot:head(jobTitle)>
                {{ $t("users.table.jobTitle") }} 
            </template>
            <template v-slot:head(userName)>
                {{ $t("users.table.userName") }} 
            </template>
            <template v-slot:head(password)>
                {{ $t("users.table.password") }} 
            </template>
            <template v-slot:head(status)>
                Actif
            </template>
            <template v-slot:head(clients)>
                {{ $t("users.table.clients") }} 
            </template>
            <!-- <template v-slot:head(privileges)>
                {{ $t("users.table.privileges") }} 
            </template> -->
            <template v-slot:cell(password)="{item}">
                <b-button @click="changePassword(item)"  size="sm" variant="outline-dark"  >
                    <i class="fas fa-key font-size-16 align-middle mr-md-2"></i><span class="d-none d-md-inline">{{$t('users.changePassword')}}</span>
                </b-button>
            </template>
            <template v-slot:cell(status)="{value}">
                <i :class="value===1 ? 'fas fa-check text-success' : 'fas fa-ban text-danger' " ></i>
            </template>
            <template v-slot:cell(isPartner)="{value}">
                <i :class="value ? 'fas fa-regular fa-handshake font-size-14 text-primary' : '' " ></i>
            </template>

            <template v-slot:cell(isAdmin)="{value}">
                <i :class="value ? 'fas fa-user-graduate font-size-18 text-success' : 'fas fa-user-alt-slash text-danger' " ></i>
            </template>

            <template v-slot:cell(jobTitle)="{value}">
                {{value ? value : "_"}}
            </template>

            <template v-slot:cell(actions)="{item}">
                <a  title="modifier" href="javascript:void(0);"  @click="editUser(item)" class="action-icon text-warning pr-2" >
                    <img alt="Edit" width="20px" src="@/assets/icons/pencil.svg" style="cursor: pointer;"/>
                </a>
            </template>

            </b-table>
            <span v-if="!isUsersTableBusy && usersList && !usersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('users.table.empty')}} </span>

        </div>
        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getUsers()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMain.currentPage" :disabled="isUsersTableBusy" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="getUsers()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        <b-modal
            v-model="showPasswordModal"
            :title="$t('users.passwordModal.title')+selectedUser.name" 
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
        >
            <div class="form-group row">
                <label class="col-5 col-form-label" for="pwd">{{$t('users.passwordModal.label')}} </label>
                <div class="col-5">
                        <b-input-group >
                          <b-form-input v-model="newPassword"  @keyup.native.enter="updatePassword()" :type="passwordHidden ? 'password':'text'" ></b-form-input>
                            
                          <template v-slot:append>
                              <b-button  size="sm" variant="dark"   >
                                <i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword ()" ></i>
                              </b-button>
                          </template> 
                        </b-input-group>
                </div>
                <div class="col-1"/>
                <div class="col-1">
                    <b-button variant="success" @click="updatePassword()">
                        <i class="fas fa-save font-size-14 align-middle  " ></i>
                    </b-button>
                </div>
            </div>

        </b-modal>

        <b-modal
                v-model="editUsersModal"
                :title="selectedUser.id ? $t('users.editUsersModal.title1') : $t('users.editUsersModal.title2') " 
                centered 
                title-class="text-primary"
                title-tag="h5"
                header-close-variant="danger"
                size="lg"
                no-close-on-backdrop
        >

            <div class="row">

                <div class="col-12 col-sm-6">
                    <div class="float-left">
                        <div  class="form-group  ">
                            <b-form-checkbox
                                value="1"
                                unchecked-value="0"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                v-model="selectedUser.status"
                                >   
                                <span class="font-size-14" :class="selectedUser.status == 1 ? 'text-info' : 'text-muted'">{{selectedUser.status == 1 ? $t('users.editUsersModal.status.active') : $t('users.editUsersModal.status.disabled')}}</span>
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>
            

                <!-- <div class="col-12 col-sm-6">
                    <div class="float-left">
                        <div  class="form-group  ">
                            <b-form-checkbox
                                value="true"
                                unchecked-value="false"
                                class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-0 mt-0"
                                v-model="selectedUser.isAdmin"
                                >   
                                <span class="font-size-14" :class="selectedUser.isAdmin ? 'text-info' : 'text-info'">{{selectedUser.isAdmin ? 'Administrateur' :  'Administrateur' }}</span>
                            </b-form-checkbox>
                        </div>
                    </div>
                </div> -->

            </div>

            <div class="row mt-4" style="width:100%">
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('users.editUsersModal.table.name')}} </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.name"
                    />
                </div>
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('users.editUsersModal.table.userName')}} </label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.userName"

                    />
                </div>
                <div v-if="isNew" class="form-group col-sm-4 pr-2">
                    <label >{{$t('users.editUsersModal.table.password')}}</label>
                    <form autocomplete="off">
                        <div class="input-group">
                            <input class="form-control" :type="passwordHidden ? 'password':'text'" autocomplete="new-password" v-model="selectedUser.password">
                            <div class="input-group-append">
                                <span class="input-group-text"><i :class="passwordHidden ?'fa fa-eye-slash':'display-eye fa fa-eye'" @click="showHidePassword" ></i></span>
                            </div>
                        </div>
                    </form>
                </div>

               

                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('users.editUsersModal.table.phone')}}</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.phone"

                    />
                </div>
                <div class="form-group col-sm-4 pr-2">
                    <label >{{$t('users.editUsersModal.table.jobTitle')}}</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="selectedUser.jobTitle"

                    />
                </div>

                

            </div>

            <template v-slot:modal-footer>
            <b-button variant="secondary" @click="editUsersModal = false" size="md">{{$t('buttons.cancel')}}</b-button>
            <b-button  variant="primary" @click="saveUser()" size="md" ><span class="text-white font-weight-bold">{{$t('buttons.save')}}</span></b-button>
            </template>

        </b-modal>
       

        <b-modal
            v-model="showClientsModal"
            :title="$t('users.tradersCustomersModal.title')+selectedUser.name" 
            hide-footer 
            centered 
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            no-close-on-backdrop
            size="lg"

            @hide="onClientsModalClose()">

        <b-form-group :label="$t('users.tradersCustomersModal.nameFilter.label')" >
            <b-input-group  >
                <b-form-input :placeholder="$t('users.tradersCustomersModal.nameFilter.placeholder')"   v-model="customersFilter"   @keyup.native.enter="getUsersClients() "
                    ></b-form-input>                              
                <template v-slot:append>
                    <b-button variant="danger" @click="getUsersClients()" >
                    <i class="bx bx-search-alt font-weight-bold font-size-16  align-middle"></i>
                    </b-button>
                </template>
            </b-input-group>
        </b-form-group>
        <span v-if="!customerTableBusy & !clientsList.length" class="d-flex justify-content-center m-4 text-danger" > {{$t('users.tradersCustomersModal.table.empty')}} </span>
        <simplebar  style="max-height: 25em;min-height: 25em;"  >

            <div class="table-responsive" style="max-height: 25em;min-height: 25em;" > 
                    <b-table 
                    :busy="customerTableBusy"
                    :striped="true"
                    :small="true"
                    :hover="true"
                    :items="clientsList"
                    :fields="selectedUser.hasAdminPrivilege ? customersListFieldsForAdmin :customersListFields"
                    :perPage="pagemodelCustomersList.perPage"
                    class="table  "
                    thead-class="d-none"
                    id="my-table"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center my-2">
                                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                            </div>
                        </template>

                        <template v-slot:head(companyName)>
                            {{ $t("users.tradersCustomersModal.table.name") }} 
                        </template>
                        <template v-slot:head(country)>
                            {{ $t("users.tradersCustomersModal.table.country") }} 
                        </template>
                        <template v-slot:head(city)>
                            {{ $t("users.tradersCustomersModal.table.city") }} 
                        </template>

                        <!-- <template v-slot:cell(companyName)="{item, value}">
                            <code>{{item.code}}</code> {{ value }}
                        </template> -->

                        <template v-slot:cell(selection)="{item}">
                        <b-form-checkbox
                            value="1"
                            unchecked-value="0"
                            class="custom-checkbox-success "
                            v-model="item.isAddedToUser"
                            @input="editSelection(item)"
                            :disabled="editSelectionStaring"
                            ></b-form-checkbox>
                        </template>
                    </b-table>
            </div>

        </simplebar>

           <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getUsersClients(selectedUser)"  v-model="pagemodelCustomersList.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }}</span><span class="font-weight-bold"> {{pagemodelCustomersList.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelCustomersList.currentPage" :disabled="customerTableBusy" :per-page="pagemodelCustomersList.pageSize" :total-rows="pagemodelCustomersList.totalRows" @input="getUsersClients(selectedUser)" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
        </b-modal>


    </div>
</template>